export class AtlasProject {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AtlasProject.attributeTypeMap;
    }
    constructor() {
    }
}
